import React, { useEffect, useState } from "react";
import changePasswordImg from '../../../assets/img/change-password.jpg';
import FormRenderer, { ComponentMapper, FormTemplate } from "../../common/FormRenderer";
import { preventDefault } from "../../../utils/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { Button } from "react-bootstrap";
import { clearUserSession, useChangePassword } from "../../../backend/auth";
import PageLoader from "../../shared/PageLoader";
import { toast } from "react-toastify";
import { API_RESULT, ERROR_MESSAGES } from "../../../utils/constants";
import { LOGIN_FIELDS } from "./Authenticate.constants";
import { navigate } from "raviger";
import { getBasePath } from "../../../App";
import { AxiosError } from "axios";

function ChangePassword() {
    const [changePwdSuccess, setChangePwdSuccess] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [form, setForm] = useState<any>({});
    const [passwordError, setPasswordError] = useState<string>('');
    const { changePassword } = useChangePassword((response: any) => {
        setSubmitting(false);
        if(response instanceof AxiosError) {
            const { data } = (response || {}).response || {};
            const error = (data || {}).error || (data || {}).message || ((data || {}).errors && (data || {}).errors.join(',')) || ERROR_MESSAGES.ERROR;
            toast.error(error);
        } else {
            setChangePwdSuccess(true);
        }
    }, (error: any) => {
        setSubmitting(false);
        const { data } = (error || {}).response || {};
        error = (data || {}).error || (data || {}).message || ((data || {}).errors && (data || {}).errors.join(',')) || ERROR_MESSAGES.DEFAULT;
        toast.error(error);
    });

    function signIn(event: any) {
        preventDefault(event);
        navigate(`${getBasePath()}/`);
        window.location.reload();
    }

    const schema = {
        fields: [{ ...LOGIN_FIELDS.RESET_TOKEN }, { ...LOGIN_FIELDS.NEW_PASSWORD }, { ...LOGIN_FIELDS.CONFIRM_PASSWORD }],
    };

    function debugForm(_form: any) {
        setForm(_form);
        const { newPassword, confirmPassword } = _form.values || {};
        if (newPassword && confirmPassword && newPassword !== confirmPassword) {
            setPasswordError('New password and Re-enter password should be same');
        } else {
            setPasswordError('');
        }
    }

    function isInvalid() {
        return !form.valid || !!passwordError;
    }

    function handleSubmit(event: any) {
        preventDefault(event);
        const { resetToken, newPassword, confirmPassword } = form.values || {};

        if (isInvalid()) {
            if (passwordError) {
                toast.error(passwordError);
            } else {
                toast.error("Please fill all the mandatory fields.");
            }
            return;
        }

        setSubmitting(true);
        changePassword({ newPassword, token: resetToken });
    }

    useEffect(() => {
        clearUserSession();
    }, []);

    return (
        <>
            {
                !changePwdSuccess ?
                    <div className="row m-0">
                        <div className="col-md-7 text-center pt-5">
                            <img className="py-5" src={changePasswordImg} alt="First slide" width="75%" />
                        </div>
                        <div className="col-md-5 pt-5 my-5">
                            <div className="card shadow px-3 pt-4 pb-5 mb-5 bg-body rounded">
                                <div className="p-0 text-center pt-2 border-bottom">
                                    <h5 className="text-appprimary fw-bold text-xl">Reset Password</h5>
                                </div>
                                <div className="col-md-10 m-auto">
                                    <div className="pt-4 pb-4">
                                        <span className="fs-6 text-black-600"> Instructions </span>
                                        <div><small className="text-error text-sm">Enter the reset token you received in your email along with your new password. Password must be at least 12 characters long and must include at least one lowercase letter, one uppercase letter, one digit and one special character. The first character of the password cannot be a special character.</small></div>
                                    </div>
                                    <div className="col-md-10 mx-auto">
                                        <FormRenderer FormTemplate={FormTemplate}
                                            initialValues={{ hideButtons: true }}
                                            componentMapper={ComponentMapper}
                                            schema={schema}
                                            debug={debugForm}
                                        />
                                        {passwordError && (
                                            <div className="text-error text-center mb-3 mt-2">
                                                <small>{passwordError}</small>
                                            </div>
                                        )}
                                        <div className="d-flex flex-row mt-4 justify-content-center">
                                            <Button
                                                variant="primary"
                                                type="button"
                                                className="btn btn-primary px-4 w-100"
                                                disabled={isInvalid()}
                                                onClick={handleSubmit}
                                            >
                                                Change Password
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex flex-column align-items-center">
                                <span className="text-black-600">-or-</span>
                                <div className="mt-4">Back to <a href="/" className="underline text-dark-gray" onClick={signIn}>LOGIN</a></div>
                            </div>
                        </div>
                    </div> :
                    <div className="row m-0 overflow-hidden justify-content-center align-items-center">
                        <div className="card border-0 rounded-0 h-100">
                            <div className="row m-0">
                                <div className="col-md-5 pt-5 my-5 mx-auto">
                                    <div className="card shadow px-3 pt-4 pb-5 mb-5 bg-body rounded">
                                        <div className="d-flex flex-column align-items-center pt-5">
                                            <FontAwesomeIcon icon={faCircleCheck} style={{ fontSize: '106px' }} className="mb-4 text-success" />
                                            <div className="fs-5 text-success">Password Changed successfully</div>
                                            <p className="pt-5 mt-5 text-black-600">Please log in with the new password.</p>
                                            <div className="text-center pt-4">
                                                <Button variant="primary" type="submit" className={`btn btn-primary px-4`} onClick={signIn}>
                                                    Back To LOGIN
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            }
            {submitting && <PageLoader />}
        </>
    )
}

export default ChangePassword;
